module.exports = __webpack_public_path__ + "static/media/icon-access.fd3ea0ff.svg";